import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ParameterResult } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface TownParams extends DefaultHttpHeaders {
  /** Unique identifier of town */
  townCode: string;
}

@Injectable()
export class TownService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Service for obtaining Q&B town by code
   * Service for obtaining Q&B town by code
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Catalog/getComeroundTownById
   */
  town(params: TownParams): Observable<ParameterResult> {
    const pathParams = {
      townCode: params.townCode,
    };
    return this.get<ParameterResult>({
      suffix: `/comeround/catalog/town/${pathParams.townCode}`,
    });
  }
}
